export default __webpack_public_path__ + "static/media/img10.24666727.PNG";